package com.ustadmobile.core.util.ext

actual fun String.base64StringToByteArray(): ByteArray = TODO("Not implemented on JS yet")

